<template>
  <div>
    <PageHeader :items="items" />
    <b-tabs content-class="mt-2">
      <!-- Customer Tab -->
      <b-tab title="Customer">
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <TextInput
                  v-model="form.companyName"
                  type="text"
                  :disabled="true"
                  :label="$t('companyName')"
                  :tooltipMessage="$t('companyName')"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <TextInput
                  v-model="form.addressLine1"
                  type="text"
                  :label="$t('addressLine1')"
                  :required="false"
                  :disabled="true"
                />
              </b-col>
              <b-col cols="12" lg="4" md="4" class="mb-1">
                <TextInput
                  v-model="form.addressLine2"
                  type="text"
                  :disabled="true"
                  :label="$t('addressLine2')"
                />
              </b-col>
              <b-col cols="12" lg="4" md="4" class="mb-1">
                <TextInput
                  v-model="form.city"
                  type="text"
                  :disabled="true"
                  :label="$t('city')"
                  :required="false"
                />
              </b-col>
              <b-col cols="12" lg="4" md="4" class="mb-1">
                  <TextInput
                    v-model="form.shortName"
                    type="text"
                    :disabled="true"
                    :label="$t('shortName')"
                    :tooltipMessage="$t('shortName')"
                  />
                </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <TextInput
                  v-model="form.zipCode"
                  type="text"
                  :disabled="true"
                  :label="$t('zip')"
                  :required="false"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <div class="form-group">
                  <label class="form-label input-label" for="country">{{
                    $t("country")
                  }}</label>
                  <multi-select
                    :disabled="true"
                    :multiple="false"
                    label="name"
                    track-by="name"
                    :options="countries"
                    :key="countries"
                    v-model="form.country"
                  />
                </div>
              </b-col>
              <b-col cols="12" :lg="showCreatedBy ? 4 : 6" :md="showCreatedBy ? 4 : 6" class="mb-1">
                <TextInput
                  v-model="form.vatId"
                  :disabled="true"
                  type="text"
                  :label="$t('vatId')"
                />
              </b-col>
              <b-col cols="12" :lg="showCreatedBy ? 4 : 6" :md="showCreatedBy ? 4 : 6" class="mb-1">
                <TextInput
                  v-model="form.phone"
                  :disabled="true"
                  type="text"
                  :label="$t('phone')"
                />
              </b-col>
              <b-col v-if="showCreatedBy" cols="12" lg="4" md="4" class="mb-1">
                <TextInput
                  v-model="form.createdBy"
                  :disabled="true"
                  type="text"
                  :label="$t('createdBy')"
                />
              </b-col>
              <b-col cols="12" lg="4" md="4" class="mb-1">
                <label class="input-label form-label" for="cars">{{
                  $t("status")
                }}</label>
                <select
                  :disabled="true"
                  class="input-form form-control"
                  v-model="form.status"
                >
                <option value="new">
                    {{ $t("new") }}
                  </option>
                  <option value="test">
                    {{ $t("test") }}
                  </option>
                  <option value="active">
                    {{ $t("active") }}
                  </option>
                  <option value="inactive">
                    {{ $t("inactive") }}
                  </option>
                </select>
              </b-col>
              <b-col cols="12" lg="4" md="4" class="mb-1">
                <label class="input-label form-label">{{
                  $t("type")
                }}</label>
                <select
                  :disabled="true"
                  class="input-form form-control"
                  v-model="form.type"
                >
                  <option value="">
                    {{ $t("selectOption") }}
                  </option>
                  <option value="practice">
                    practice  
                  </option>
                  <option value="lab">
                    lab
                  </option>
                  <option value="other">
                    other
                  </option>
                </select>
              </b-col>
              <div class="col-md-4 mb-1">
                <b-form-group class="m-0">
                  <label class="input-label form-label"
                    >{{ $t("preferredContactLanguage") }}
                  </label>
                  <select
                    disabled
                    class="form-control"
                    v-model="form.contactLanguage"
                  >
                    <option
                      v-for="language in languages"
                      :value="language"
                      :key="language"
                    >
                      {{ language }}
                    </option>
                  </select>
                </b-form-group>
              </div>
              <div class="col-md-4 mb-1">
                <b-form-group class="m-0">
                  <label class="input-label form-label" for="cars">
                    {{ $t("Owners") }}
                  </label>
                  <MultiSelectInput
                    v-model="form.owners"
                    :options="modifiedUsers"
                    :label="'full_name'"
                    trackBy="id"
                    :key="form.owners"
                    :query="{ company_id: $route.params.id }"
                    moduleName="users"
                    :multiple="true"
                    :isDisabled="true"
                    :searchParamName="`search_string`"
                    ><template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.first_name }}
                          {{ props.option.last_name }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                </b-form-group>
              </div>
              <b-col cols="12" lg="4" md="4" class="mb-1">
                <div class="form-group">
                  <label class="input-label form-label"
                    >{{ $t("assignedToSalesPartner") }}
                  </label>
                  <MultiSelectInput
                    :isDisabled="true"
                    :key="form.salesPartnerId"
                    v-model="form.salesPartnerId"
                    :options="salesPartners"
                    label="companyName"
                    trackBy="id"
                    moduleName="customers"
                    :multiple="false"
                    :action="'salesPartners'"
                    :query="{ isSalesPartner: true, isMultiSelect: true }"
                    ><template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.companyNumber }} -
                          {{ props.option.companyName }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                </div>
              </b-col>
              <!-- <b-col cols="12" lg="4" md="4" class="mb-1">
                <div class="form-group">
                  <label class="input-label form-label"
                    >{{ $t("assignedToReseller") }}
                  </label>
                  <MultiSelectInput
                    :isDisabled="true"
                    :key="form.resellerId"
                    v-model="form.resellerId"
                    :options="resellers"
                    label="companyName"
                    trackBy="id"
                    moduleName="customers"
                    :multiple="false"
                    :action="'resellers'"
                    :query="{ isReseller: true }"
                    ><template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.companyNumber }} -
                          {{ props.option.companyName }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                </div>
              </b-col>

              <b-col cols="12" lg="4" md="4" class="mb-1">
                <div class="form-group">
                  <label class="input-label form-label"
                    >{{ $t("assignedToServicePartner") }}
                  </label>
                  <MultiSelectInput
                    :isDisabled="true"
                    v-model="form.servicePartnerId"
                    :key="form.servicePartnerId"
                    :options="servicePartners"
                    label="companyName"
                    trackBy="id"
                    moduleName="customers"
                    :multiple="false"
                    :action="'servicePartners'"
                    :query="{ isServicePartner: true }"
                    ><template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.companyNumber }} -
                          {{ props.option.companyName }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                </div>
              </b-col> -->
              
              <b-col cols="12" lg="4" md="4" class="mb-1">
                <div class="form-group mt-1">
                  <label class="input-label form-label" for="cars">{{
                    $t("salesPartner")
                  }}</label>

                  <input
                    :disabled="true"
                    id="salesPartner"
                    class="form-check-input-custom ml-2"
                    v-model="form.salesPartner"
                    type="checkbox"
                  />
                </div>
              </b-col>
              <!-- <b-col cols="12" lg="4" md="4" class="mb-1">
                <div class="form-group mt-1">
                  <label class="input-label form-label" for="cars">{{
                    $t("commercialAgent")
                  }}</label>
                  <input
                    id="commericalAgent"
                    :disabled="true"
                    class="form-check-input-custom ml-2"
                    v-model="form.commericalAgent"
                    type="checkbox"
                  />
                </div>
              </b-col> -->
              <b-col cols="12" lg="4" md="4" class="mb-1">
                <div class="form-group mt-1">
                  <label class="input-label form-label" for="affiliate">
                    {{ $t("affiliate") }}
                  </label>
                  <input
                    id="affiliate"
                    :disabled="true"
                    class="form-check-input-custom ml-2"
                    v-model="form.affiliate"
                    type="checkbox"
                  />
                </div>
              </b-col>
              <b-col cols="12" lg="4" md="4" class="mb-1">
                <div class="form-group mt-1">
                  <label class="input-label form-label" for="userGuide">
                    {{ $t("userGuide") }}
                  </label>
                  <input
                    id="userGuide"
                    :disabled="true"
                    class="form-check-input-custom ml-2"
                    v-model="form.userGuide"
                    type="checkbox"
                  />
                </div>
              </b-col>
              <b-col lg="4" md="4" cols="12" class="mb-1">
                <label class="input-label form-label">
                  {{ $t("salesPerson") }}
                </label>
                <MultiSelectInput
                  v-model="form.salesPerson"
                  :options="modifiedSalesPersons"
                  :label="'full_name'"
                  trackBy="id"
                  :key="form.salesPerson"
                  :multiple="false"
                  moduleName="auth"
                  :action="'salesPersons'"
                  :isDisabled="true"
                  :searchParamName="'search_string'"
                >
                  <template #option="{ props }">
                    <div>
                      <p>
                        {{ props.option.first_name }} {{ props.option.last_name }}
                      </p>
                    </div>
                  </template>
                </MultiSelectInput>
              </b-col>
              <b-col lg="4" md="4" cols="12" class="mb-1">
                <label class="input-label form-label">
                  {{ $t("referralLink") }}
                </label>
                <MultiSelectInput
                  v-model="form.referralLinkId"
                  :options="referralLinks"
                  label="name"
                  trackBy="referralId"
                  :key="form.referralLinkId"
                  :multiple="false"
                  moduleName="referralLinks"
                  :action="'getReferralLinks'"
                  :isDisabled="true"
                >
                </MultiSelectInput>
              </b-col>
              <!-- <b-col
                v-if="form.salesPartner"
                cols="12"
                lg="12"
                md="12"
                class="mb-1"
              >
                <div class="form-group mt-1">
                  <label class="input-label form-label" for="cars">{{
                    $t("canEditCommissions")
                  }}</label>

                  <input
                    id="salesPartner"
                    :disabled="true"
                    class="form-check-input-custom ml-2"
                    v-model="form.canEditCommissions"
                    type="checkbox"
                  />
                </div>
              </b-col>
              <b-col cols="12" lg="3" md="3" class="mb-1">
                <text-input
                  :type="'number'"
                  v-model="form.commDistance1"
                  :label="$t('commDistance1')"
                  :disabled="true"
                  aria-label="Commission Distance 1"
                />
              </b-col>
              <b-col cols="12" lg="3" md="3" class="mb-1">
                <text-input
                  :type="'number'"
                  v-model="form.commDistance2"
                  :label="$t('commDistance2')"
                  :disabled="true"
                  aria-label="Commission Distance 2"
                />
              </b-col>
              <b-col cols="12" lg="3" md="3" class="mb-1">
                <text-input
                  :type="'number'"
                  v-model="form.commDistance3"
                  :label="$t('commDistance3')"
                  :disabled="true"
                  aria-label="Commission Distance 3"
                />
              </b-col>
              <b-col cols="12" lg="3" md="3" class="mb-1">
                <text-input
                  :type="'number'"
                  v-model="form.commDistanceN"
                  :label="$t('commDistanceN')"
                  :disabled="true"
                  aria-label="Commission Distance N"
                />
              </b-col> -->
            </b-row>
          </div>
        </div>
        <div class="card">
          <div class="card-header" aria-label="Payment Details Header">
            <h3 class="card-title">
              {{ $t("paymentDetails") }}
            </h3>
          </div>

          <div class="card-body" aria-label="Payment Detials Body">
            <b-row>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <text-input
                  :disabled="true"
                  v-model="form.invoiceEmailAddress"
                  :label="$t('invoiceEmailAddress')"
                  aria-label="Invoice Email Address Input"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <text-input
                  :disabled="true"
                  v-model="form.companyEmail"
                  :label="$t('companyEmail')"
                  aria-label="Company Email Input"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <text-input
                  :disabled="true"
                  v-model="form.warningMailAddress"
                  :label="$t('warningMailAddress')"
                  aria-label="Invoice Email Address Input"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <label class="input-label form-label" for="cars">{{
                  $t("applyReverseCharge")
                }}</label>

                <input
                  :disabled="true"
                  id="active"
                  class="form-check-input-custom ml-2"
                  v-model="form.applyReverseCharge"
                  type="checkbox"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <text-input
                  :disabled="true"
                  v-model="form.externalOrderNumber"
                  :label="$t('externalOrderNumber')"
                  aria-label="External Order Number"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <TextInput
                  v-model="form.pricePerUnit"
                  type="number"
                  :min="0"
                  :disabled="true"
                  :label="$t('pricePerUnit')"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <TextInput
                  v-model="form.dentawaxPricePerUnit"
                  type="number"
                  :min="0"
                  :disabled="true"
                  :label="$t('dentawaxPricePerUnit')"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <TextInput
                  v-model="form.dentaTempPricePerUnit"
                  type="number"
                  :min="0"
                  :disabled="true"
                  :label="$t('dentaTempPricePerUnit')"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <div class="form-group">
                  <label class="form-label input-label">
                    {{ $t("payingCurrency") }}
                  </label>
                  <multi-select
                    v-model="form.payingCurrency"
                    :multiple="false"
                    :disabled="true"
                    label="label"
                    track-by="country"
                    :options="countryCurrencies"
                    :placeholder="$t('selectOption')"
                  />
                </div>
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <text-input
                  :type="'number'"
                  :disabled="true"
                  v-model="form.credits"
                  :label="$t('dentalTwinCredits')"
                  aria-label="DentalTwin Credits"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <text-input
                  :disabled="true"
                  v-model="form.notificationMail"
                  :label="$t('notificationMail')"
                  aria-label="Notification Mail"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <TextInput
                  v-model="form.freeCases"
                  type="number"
                  :disabled="true"
                  :label="$t('freeCases')"
                  :tooltipMessage="$t('freeCases')"
                  :required="false"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <DatePicker
                  v-model="freeCasesExpiryDate"
                  :label="$t('freeCasesExpiryDate')"
                  :required="false"
                  :isDisabled="true"
                  :isLeftIcon="true"
                  :options="{
                    enableTime: false,
                  }"
                  :leftIconName="'dateIcon'"
                />
              </b-col>
            </b-row>
          </div>
        </div>
        <BankDetails v-model="form.bankDetails" :isDisabled="true" />
      </b-tab>
      <b-tab v-if="$can('list-users')" :title="$t('users')" lazy>
        <Users />
      </b-tab>
      <b-tab :title="$t('creditFlows')" lazy>
        <Balances />
      </b-tab>
      <b-tab :title="$t('creditHistory')" lazy>
        <CreditHistory />
      </b-tab>
      <b-tab :title="$t('cases')" lazy>
        <CasesIndex :embedded="true" :companyId="$route.params.id" />
      </b-tab>
      <b-tab
        :title="$t('referralLinks')"
        v-if="$can('backoffice-referral-link.list')"
        lazy
      >
        <ReferralLinks :isShow="true" />
      </b-tab>
      <b-tab
        v-if="$can('backoffice-referral.list')"
        :title="$t('referral')"
        lazy
      >
        <Referral :isShow="true" />
      </b-tab>
      <b-tab
        v-if="
          $can('backoffice.customer-activity.list') ||
          $can('backoffice.customer-note.list')
        "
        :title="$t('activityHistory')"
        lazy
      >
        <ActivityHistory :companyName="form.companyName" :notificationMail="form.notificationMail" />
      </b-tab>
      <!-- <b-tab :title="$t('commissions')" lazy>
        <Commissions />
      </b-tab> -->
    </b-tabs>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import DatePicker from "@/components/DatePicker.vue";
import Users from "./components/Users.vue";
import BankDetails from "./components/BankDetails.vue";
import PageHeader from "@/components/PageHeader.vue";
import MultiSelect from "vue-multiselect";
import CreditHistory from "./components/CreditHistory.vue";
import CasesIndex from "@/views/my-cases/Index.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import Referral from "@/views/referral/components/Referral.vue";
import ActivityHistory from "./components/ActivityHistory.vue";
import ReferralLinks from "@/views/referral/components/ReferralLinks.vue";
import Balances from "./components/Balances.vue";
// import Commissions from "./components/Commissions.vue";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import { required, email } from "@validations";
import countries from "@/assets/data/countries.json";
import countryCurrencies from "@/assets/data/country-currencies.json";

export default {
  components: {
    TextInput,
    DatePicker,
    PageHeader,
    MultiSelect,
    ValidationProvider,
    ValidationObserver,
    MultiSelectInput,
    Balances,
    Users,
    CreditHistory,
    CasesIndex,
    Referral,
    ReferralLinks,
    ActivityHistory,
    BankDetails,
    // Commissions,
  },
  computed: {
    ...mapGetters("customers", [
      "resellers",
      "salesPartners",
      "servicePartners",
    ]),
    ...mapGetters("users", ["users"]),
    ...mapGetters("auth", ["salesPersons"]),
    ...mapGetters("referralLinks", ["referralLinks"]),
    modifiedUsers() {
      return this.users.map((user) => ({
        ...user,
        full_name: `${user.first_name} ${user.last_name}`,
      }));
    },
    modifiedSalesPersons() {
      if (!this.salesPersons || !Array.isArray(this.salesPersons)) {
        return [];
      }
      return this.salesPersons
        .filter((salesPerson) => {
          return salesPerson.roles && Array.isArray(salesPerson.roles) && salesPerson.roles.includes("admin");
        })
        .map((salesPerson) => ({
          ...salesPerson,
          full_name: `${salesPerson.first_name} ${salesPerson.last_name}`,
        }));
    },
    showCreatedBy() {
      return this.form.createdBy && this.form.createdBy.trim() !== "";
    },
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("customers"),
          to: "/customers",
        },
        {
          html: `${this.$t("show")}${this.form.companyName ? ' <strong>[' + this.form.companyName + ']</strong>' : ''}`,
          active: true,
        },
      ];
    },
  },
  data() {
    return {
      countries,
      countryCurrencies,
      languages: ["English", "French", "German", "Spanish", "Turkish"],
      referralServiceBaseUrl: process.env.VUE_APP_REFERRAL_BASEURL || "",
      freeCasesExpiryDate: null,
      form: {
        companyName: "",
        companyEmail: "",
        shortName: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        zipCode: "",
        country: "",
        credits: "",
        contactLanguage: "",
        vatId: "",
        phone: "",
        createdBy: "",
        // commDistance1: "",
        // commDistance2: "",
        // commDistance3: "",
        // commDistanceN: "",
        status: "",
        type: "",
        owners: [],
        // servicePartner: false,
        servicePartnerId: "",
        bankDetails: [],
        externalOrderNumber: "",
        pricePerUnit: "",
        dentawaxPricePerUnit: "",
        dentaTempPricePerUnit: "",
        payingCurrency: null,
        invoiceEmailAddress: "",
        warningMailAddress: "",
        applyReverseCharge: false,
        resellerId: "",
        salesPartnerId: "",
        // reseller: false,
        // endUser: false,
        salesPartner: false,
        commercialAgent: false,
        affiliate: false,
        userGuide: false,
        // canEditCommissions: false,
        notificationMail: "",
        freeCases: "",
        salesPerson: null,
        referralLinkId: "",
        // freeTestLowerTeeth: "",
        // freeTestUpperTeeth: "",
      },
    };
  },
  async created() {
    try {
      this.$store.commit("showLoader", true);
      await this.$store.dispatch("users/list", {
        company_id: this.$route.params.id,
      });
      await this.loadUsers();
      await this.$store.dispatch("customers/salesPartners", {
        isSalesPartner: true,
      });
      await this.$store.dispatch("referralLinks/getReferralLinks");
      await this.loadItems();
      this.$store.commit("showLoader", false);
    } catch (e) {
      console.error("api error ___", e);
      this.$store.commit("showLoader", false);
    }
  },
  methods: {
    async loadUsers() {
      await this.$store.dispatch("auth/salesPersons");
    },
    async loadItems() {
      try {
        await this.$store
          .dispatch("customers/show", this.$route.params.id)
          .then(async (res) => {
            let data = res?.data?.modelData;
            this.form.companyName = data.companyName;
            this.form.companyEmail = data.companyEmail || "";
            this.form.shortName = data.shortName || "";
            this.form.addressLine1 = data.addressLine1;
            this.form.addressLine2 = data.addressLine2;
            this.form.zipCode = data.zipCode;
            this.form.credits = data.credits;
            this.form.userGuide = data.userGuide;
            this.form.city = data.city;
            this.form.status = data.status;
            this.form.type = data.type || "";
            // this.form.commDistance1 = data.commDistance1;
            // this.form.commDistance2 = data.commDistance2;
            // this.form.commDistance3 = data.commDistance3;
            // this.form.commDistanceN = data.commDistanceN;

            this.form.contactLanguage = data.preferredContactLanguage;
            this.form.owners = this.modifiedUsers.filter((user) =>
              data.owners.includes(user.id)
            );
            // this.form.freeTestUpperTeeth = data.freeTestUpperTeeth;
            // this.form.freeTestLowerTeeth = data.freeTestLowerTeeth;
            this.form.freeCases = data.freeCases;
            this.freeCasesExpiryDate = data.freeCasesExpiryDate;
            const matchedFormCountry = this.countries.find(
              (country) => country.name === data.country
            );
            this.form.country = matchedFormCountry || null;
            this.form.externalOrderNumber = data.externalOrderNumber;
            this.form.pricePerUnit = data.pricePerUnit ?? "";
            this.form.dentawaxPricePerUnit = data.dentawaxPricePerUnit ?? "";
            this.form.dentaTempPricePerUnit = data.dentaTempPricePerUnit ?? "";
            const payingCurrencyValue =
              data.payingCurrency ?? data.payingCurrency ?? "";
            this.form.payingCurrency =
              this.countryCurrencies.find(
                (item) => item.currency === String(payingCurrencyValue).toLowerCase()
              ) || null;
            this.form.vatId = data.vatId;
            this.form.phone = data.phone;
            this.form.invoiceEmailAddress = data.invoiceEmailAddress;
            this.form.warningMailAddress = data.warningMailAddress;

            this.form.bankDetails = data.bankDetails.map((bank) => {
              const matchedCountry = this.countries.find(
                (country) => country.name === bank.country_name
              );

              return {
                bankName: bank.bankName || "",
                swift: bank.swift || "",
                iban: bank.iban || "",
                routing_number: bank.routing_number || "",
                account_number: bank.account_number || "",
                institution_number: bank.institution_number || "",
                transit_number: bank.transit_number || "",
                bsb_code: bank.bsb_code || "",
                branch_code: bank.branch_code || "",
                bank_code: bank.bank_code || "",
                country: matchedCountry || null, // multiselect expects object
              };
            });

            this.form.notificationMail = data.notificationMail;
            this.form.applyReverseCharge = data.applyReverseCharge;
            // this.form.reseller = data.reseller;
            this.form.salesPartner = data.salesPartner;
            this.form.commercialAgent = data.commercialAgent;
            this.form.affiliate = data.affiliate;
            // this.form.canEditCommissions = data.canEditCommissions;
            // this.form.endUser = data.endUser;
            // this.form.servicePartner = data.servicePartner;
            this.form.resellerId = data.resellerCompany;
            this.form.servicePartnerId = data.servicePartnerCompany;
            this.form.salesPartnerId = data.salesPartnerCompany;
            this.form.referralLinkId = data.referralLink;

            if (data.salesPerson) {
              this.$store.dispatch("users/show", {
                id: data.salesPerson,
              }).then(response => {
                this.form.salesPerson = response?.data;
                this.form.salesPerson.full_name = `${this.form.salesPerson.first_name} ${this.form.salesPerson.last_name}`;
              });
            }

            // Handle referral and createdBy logic
            if (data.referral) {
              this.form.createdBy = data.referral;
            } else if (data.createdBy) {
              try {
                const userResponse = await this.$store.dispatch("users/show", {
                  id: data.createdBy
                });
                if (userResponse?.data?.first_name && userResponse?.data?.last_name) {
                  this.form.createdBy = `${userResponse.data.first_name} ${userResponse.data.last_name}`;
                }
              } catch (error) {
                this.form.createdBy = "";
              }
            }
          });
      } catch (e) {
        console.error("api error ___", e);
      }
    },
  },
};
</script>

<style scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}

/* .page-header {
  position: sticky !important;
  top: 10px !important;
  z-index: 1000 !important;
} */
</style>
